export class ImageSizeHelper {
  static getImageSize(number: number): number {
    if (number <= 150) return 150;
    if (number <= 240) return 240;
    if (number <= 320) return 320;
    if (number <= 400) return 400;
    if (number <= 480) return 480;
    if (number <= 560) return 560;
    if (number <= 640) return 640;
    if (number <= 768) return 768;
    if (number <= 896) return 896;
    if (number <= 1024) return 1024;
    if (number <= 1280) return 1280;
    if (number <= 1536) return 1536;
    if (number <= 1920) return 1920;
    return 2560; // fallback
  }
}